export default __webpack_public_path__ + "static/manageHouses1-759ecf67921789d717a6932ea8469f5c.png";